import React from "react";
import { ToastContainer } from "react-toastify";
import { Switch, Route } from "react-router-dom";

import "jquery/dist/jquery.min.js";
import "popper.js/dist/popper.min";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

import AboutUs from "pages/about-us/about-us";
import Homepage from "./pages/homepage/homepage";
import Services from "./pages/services/services";
import ContactUs from "./pages/contact-us/contact-us";

import PageNotfound from "components/common/404";
import ComingSoon from "components/common/coming-soon/coming";

import ScrollToTop from "./utils/ScrollToTop";
import Layouts from "./layouts/layout.components";

function App() {
  return (
    <>
      <ScrollToTop>
        <Layouts>
          <Switch>
            <Route path="/" component={Homepage} exact />
            <Route path="/about" component={AboutUs} exact />
            <Route path="/blog" component={ComingSoon} exact />
            <Route path="/contact" component={ContactUs} exact />
            <Route path="/services" component={Services} exact />
            <Route path="/portfolio" component={ComingSoon} exact />

            <Route component={PageNotfound} />

            <ToastContainer autoClose={3500} />
          </Switch>
        </Layouts>
      </ScrollToTop>
    </>
  );
}

export default App;
